import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import styles from './horizontal-container.css';
export default function HorizontalContainer({ className, children, ...rest }) {
    return (_jsx("div", { className: classNames(styles.root, className), ...rest, children: children }));
}
